import Image from 'next/image';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { useAppRouter } from '@/shared/hooks/app/useAppRouter';

import { ButtonIw } from '../ButtonIw';

export const Banner = () => {
  const router = useAppRouter();

  return (
    <Container>
      <BannerImage
        src="/assets/pages/interwill/demoPreview.png"
        width={300}
        height={185}
        alt="Demo preview"
      />
      <BannerContent>
        <div>
          <BannerTitle>See a real example:</BannerTitle>
          <BannerText>
            how Yan Martin finalized his International Last Will and Testament and verified it with
            witnesses
          </BannerText>
        </div>
        <ButtonIw
          onClick={() => router.push('/interwill/demo')}
          style={{ background: COLORS.white, color: COLORS.colorPrimary, fontWeight: 700 }}
        >
          See the Final Version
        </ButtonIw>
      </BannerContent>
    </Container>
  );
};
const Container = styled.div`
  position: relative;
  max-width: 298px;

  @container (width < 922px) {
    max-width: 100%;
  }
`;

const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  position: relative;
  padding: 18px 12px;
  background: ${COLORS.colorIwBannerOverlay};
  color: ${COLORS.white};
  backdrop-filter: blur(2px);
  font-weight: 700;
  border-radius: 8px;
`;

const BannerTitle = styled.p`
  font-size: 18px;
  line-height: 26px;
`;

const BannerText = styled.p`
  font-size: 14px;
  line-height: 20px;
`;

const BannerImage = styled(Image)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;
